export default __webpack_public_path__ + "static/1_28-bd5d8bb38bc17d454830eb24151f8634.png";